import { api } from '@/core/helpers/axiosHelper';

export default {
   async get(filter_name: string) {
      return await api
         .get('/city', {
            ...cacheFirstConfig,
            params: {
               'filter[name]': filter_name,
               per_page: 20,
               page: 1,
            },
         })
         .then((response) => response?.data);
   },
};
